import * as React from 'react';
import { Redirect } from 'react-router-dom';

import {
  connect,
} from 'react-redux';

import {
  Route, Switch
} from 'react-router-dom';

import { NoMatchRoute } from './Container';

import { 
  loadAccessTokenValidation, 
  removeAccessTokenFromCookie,
  unsuccessfulAuthenticated, 
  clearAuthentification,
} from 'loopback-react-request';

import { appSettings } from '../config';
import { DashboardPage, HomePage, ImprintPage, LegalsPage, PrivacyPage, PageNotFound, TroughsPage } from './Pages';
import { ProfilePage } from './Pages/Profile';
import CombinedDispatcher from './Container/Dispatcher/CombinedDispacher';
import { selectLanguage, GlobalPrivateState, cleanSearchQuery, filterComparativeParameter, queryParameterInitialState } from 'src/api';
import {Header} from './Partials/Header';
import LoadingSpinner from './Partials/LoadingSpinner/LoadingSpinner';
import { parse } from 'qs';

export interface PrivateRouterProps {
  authenticator: GlobalPrivateState['authenticator'];
  dispatch: any;
  language: GlobalPrivateState['localize']['language'];
  location: GlobalPrivateState['router']['location'];
  threeData: GlobalPrivateState['threeData'];
  userData: GlobalPrivateState['userData'];
  validateToken: GlobalPrivateState['validateToken'];
}

class PrivateRouter extends React.Component<PrivateRouterProps, any> {
  
  componentDidMount() {
    this.validateToken();
  }
  
  componentDidUpdate() {
    const { language, userData, validateToken } = this.props;
    if (validateToken.loaded && validateToken.error && validateToken.error.statusCode) {
      removeAccessTokenFromCookie(appSettings.cookieName);
      this.props.dispatch(unsuccessfulAuthenticated());
      this.props.dispatch(clearAuthentification());
    }
    
    if (userData.loaded && userData.result && userData.result.lang !== language.selected) {
      this.props.dispatch(selectLanguage(userData.result.lang));
    }
  }

  render() {
    // Check for from and then redirect?
    const { location } = this.props;
    const search = cleanSearchQuery(location.search);
    const searchProps = parse(search);

    return (
      <>
        <Header />
        <main className="route-private">
          <CombinedDispatcher />
          {this.isLoading && !this.hasUserData && (
            <div>
              <LoadingSpinner />
            </div>
          )}
          {!this.isLoading && this.hasUserData && (
            <>
              {searchProps && searchProps.from && (
                <Redirect to={(searchProps.from as string)} />
              )}
              {this.isValidated ? (
                <Switch>
                  <Route path="/change-password/succeeded" exact={true} component={HomePage} />
                  <Route path="/change-email/succeeded" exact={true} component={HomePage} />
                  <Route path="/profile" exact={false} component={ProfilePage} />
                  <Route path="/imprint" exact={true} component={ImprintPage} />
                  <Route path="/legals" exact={true} component={LegalsPage} />
                  <Route path="/privacy-policy" exact={true} component={PrivacyPage} />
                  <Route path="/troughs" exact={true} component={TroughsPage} />
                  <Route path="/page-not-found" exact={true} component={PageNotFound} />
                  <Route path="/" exact={false} component={DashboardPage} />
                  <Route component={NoMatchRoute} />
                </Switch>
              ) : (
                <Switch>
                  <Route path="/page-not-found" exact={true} component={PageNotFound} />
                  <Route path="/" exact={false} component={HomePage} />
                  <Route component={NoMatchRoute} />
                </Switch>
              )}
            </>
          )}
        </main>
      </>
    );
  }

  private get hasUserData(): boolean {
    const { userData } = this.props;
    return userData && userData.result ? true : false;
  }

  private get isLoading(): boolean {
    const { 
      userData,
      threeData 
    } = this.props;
    return userData.updating && !userData.loaded && threeData.updating && !threeData.loaded;
  }

  private get isValidated(): boolean {
    const userData = this.props.userData.result;
    if (!userData) {
      return false;
    }
    return userData.validated;
  }

  private validateToken() {
    const { authenticator, validateToken } = this.props;
    if (!validateToken.accessToken && !validateToken.loaded && authenticator.isAuthentificated && authenticator.accessToken) {
      this.props.dispatch(
        loadAccessTokenValidation(authenticator.accessToken)
      );
    }
  }
}

export default connect((state: GlobalPrivateState) => ({
  authenticator: state.authenticator,
  language: state.localize.language,
  location: state.router.location,
  threeData: state.threeData,
  userData: state.userData,
  validateToken: state.validateToken,
}))(PrivateRouter);